import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import the JS locale files
import en from './locales/en';  // Should import as JS, not JSON
import fr from './locales/fr';
import nl from './locales/nl';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },  // These are your JS objects
      fr: { translation: fr },
      nl: { translation: nl },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
